import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsMyBetsWidget" */ './SportsMyBetsWidget'),
  modules: ['./SportsMyBetsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
